import React, { Component } from "react";
import { Form, Input, Button, Row, Col, Typography, Layout, message, notification } from "antd";
import backgroundImage from "../../assets/fondo.png";
import { ErrorItem, FormItem } from "../../Components/Items";
import { login, hasSigned } from "../../store/actions/user";
import { connect } from "react-redux";
import { Navigate } from 'react-router-dom';

const { Header, Content } = Layout;

const { Title } = Typography;

class LogIn extends Component {

    state = {
        loading: false,
    };

    onFinish(values) {
        this.setState({ loading: true });
        this.props
          .login(values)
          .then((data) => {
            this.setState({ loading: false });
            if (data?.success === 1) {
              message.info("Bienvenido " + data.nombre);
              this.setState({ redirect: <Navigate to="/panel/registros" /> });
            } else {
              message.warning(data.err);
            }
          })
          .catch((err) => {
            this.setState({ loading: false });
            console.log(err)
            notification.error({
              message: "Error inesperado",
              description: err.toString(),
            });
          });
      }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {

        if(this.state.redirect){
            return this.state.redirect;
        }

        return (
            <Layout style={{ height: "100vh" }}>
                <Header style={{ background: "#fff", display: 'flex', boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 8px", alignItems: 'center', justifyContent: window.innerWidth > 1000 ? "left" : 'center', padding: "0 20px" }}>
                    <Title level={3} style={{ margin: "0" }}>
                        Todos Somos Diferentes
                    </Title>
                </Header>
                <Content>
                    <Row
                        style={{
                            display: "flex",
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    >
                        <Col xs={22} sm={18} md={12} lg={8} xl={6}>
                            <div
                                style={{
                                    padding: "20px",
                                    background: "#fff",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Title level={3} style={{ textAlign: "center", marginBottom: "20px" }}>
                                    Ingreso
                                </Title>
                                <Form
                                    name="login"
                                    initialValues={{ remember: true }}
                                    onFinish={this.onFinish.bind(this)}
                                    onFinishFailed={this.onFinishFailed.bind(this)}
                                >
                                    <FormItem
                                        name="usuario"
                                        required
                                        rules={[{ required: true, message: "Please input your username!" }]}
                                    >
                                        <Input placeholder="Usuario" />
                                    </FormItem>

                                    <FormItem
                                        name="password"
                                        required
                                    >
                                        <Input.Password placeholder="Contraseña" />
                                    </FormItem>

                                    <FormItem>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            Ingresar
                                        </Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        );
    }
};

export default connect(null, { login, hasSigned })(LogIn);